// extracted by mini-css-extract-plugin
export default {"container":"fpfzjQIoArkufte866I4"};